import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_EPAY_API_URL; 
const ORDERS_ENDPOINT = process.env.REACT_APP_ORDER;
const PAYMENT_ENDPOINT = process.env.REACT_APP_PAYMENT;
const EPAY_API_KEY = process.env.REACT_APP_EPAY_API_KEY;

// Fetch users from the API
export const fetchOrders = async (orderNumber) => {
const headerConfig = {
		headers: {
			'STG-EPAY-INTERNAL-API-KEY': EPAY_API_KEY
		}
	};

  try {
    const response = await axios.get(`${API_BASE_URL}/${ORDERS_ENDPOINT}/${orderNumber}`, headerConfig);
    // console.log(response.data);
    return response; // This will include the response data, status, and other information
  } catch (error) {
    console.error(error);
    /*
    if (error?.response) {
    // The request was made, but the server responded with a non-2xx status code
    console.error(error?.response.data);
    console.error(error?.response.status);
    console.error(error?.response.headers);
    } else if (error?.request) {
     console.error(error?.request);
    } else {
     // Something happened in setting up the request that triggered an Error
     console.error('Error', error?.message);
    }
    console.error(error?.config);
    */
    return error;
   }
};

// Create payment request to API
export const createPayment = async (payment) => {
  const headerConfig = {
		headers: {
			'STG-EPAY-INTERNAL-API-KEY': EPAY_API_KEY
		}
	};
  try {

    const response = await axios.post(`${API_BASE_URL}/${PAYMENT_ENDPOINT}`, payment, headerConfig);
    
    //console.log('inside request ' + JSON.stringify(response));
    return response; // This will include the response data, status, and other information
  } catch (error) {
    //console.error(error);
    return error;
    /*
    if (error.response) {
    // The request was made, but the server responded with a non-2xx status code
    console.error(error.response.data);
    console.error(error.response.status);
    console.error(error.response.headers);
    } else if (error.request) {
     console.error(error.request);
    } else {
     // Something happened in setting up the request that triggered an Error
     console.error('Error', error.message);
    }
    console.error(error.config);
    */
  }
};
